import { Stack } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Chip } from '@/shared/components/ui/chip/chip';
import { TUserIdentificationChipsProps } from '@/shared/features/rbac/components/user-identification-chips/user-identification-chips.types';
import { useLoggedInUser } from '@/shared/hooks/use-logged-in-user/use-logged-in-user';

export const UserIdentificationChips: React.FC<
  TUserIdentificationChipsProps
> = ({ userId }) => {
  const { t } = useTranslation();
  const { isLoggedInUser, isOwner } = useLoggedInUser();

  if (!isOwner && !isLoggedInUser(userId)) {
    return null;
  }

  return (
    <Stack
      direction="row"
      gap="1rem"
      alignItems="center"
      justifyContent="flex-end"
      height="100%"
    >
      {isOwner(userId) && <Chip status="blue" label={t('common:owner')} />}
      {isLoggedInUser(userId) && (
        <Chip status="green" label={t('rbac:logged_user_chip')} />
      )}
    </Stack>
  );
};
